import type React from "react";

import { useState, useRef, useEffect, type KeyboardEvent } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Button,
  InputAdornment,
  type SelectChangeEvent,
  CircularProgress,
  Paper,
  Autocomplete,
  IconButton,
  Card,
  CardHeader,
  CardContent,
  InputLabel,
  Divider,
} from "@mui/material";
import dayjs from "dayjs";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface BagComponent {
  _id: string;
  bagId: string;
  bagNo: number;
  bagType: string;
  component: string;
  expiryDate: string;
  status: string;
}

const BloodCrossmatch = () => {
  // Replace Next.js router with window.location for navigation
  // const navigateTo = (path: string) => {
  //   // Clear localStorage before navigation to prevent data persistence
  //   localStorage.removeItem("selectetmatches")
  //   localStorage.removeItem("selectedBag")

  //   // Use window.location.href for navigation
  //   window.location.href = path
  // }
  const navigate = useNavigate();
  const profile = useSelector((state: any) => state?.profileSlice?.profile);
  console.log("hiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", profile);
  // Donor state
  const [donorSearchValue, setDonorSearchValue] = useState("");
  const [donorData, setDonorData] = useState<any>(null);
  const [donorSearchResults, setDonorSearchResults] = useState<any[]>([]);
  const [donorLoading, setDonorLoading] = useState(false);
  const donorSearchRef = useRef<HTMLDivElement>(null);
  const [cachedDonorData, setCachedDonorData] = useState<any[]>([]);
  const [isDonorSelected, setIsDonorSelected] = useState(false);
  // Recipient state
  const [recipientSearchValue, setRecipientSearchValue] = useState("");
  const [recipientData, setRecipientData] = useState<any>(null);
  const [recipientSearchResults, setRecipientSearchResults] = useState<any[]>(
    []
  );
  const [recipientLoading, setRecipientLoading] = useState(false);
  const recipientSearchRef = useRef<HTMLDivElement>(null);
  const [cachedRecipientData, setCachedRecipientData] = useState<any[]>([]);
  const [isRecipientSelected, setIsRecipientSelected] = useState(false);

  // Cross match ID for editing
  const [crossMatchId, setCrossMatchId] = useState<string | null>(null);
  const [isEditMode, setIsEditMode] = useState(false);
  // const [isDonorSelected, setisDonorSelected]=useState(true)

  // Form data
  const [formData, setFormData] = useState({
    donorId: "",
    recipientId: "",
    donorBedNo: "",
    recipientBedNo: "",
    donorGender: "",
    recipientGender: "Male/Female",
    donorDeliveryDate: dayjs().format("M/D/YY"),
    recipientDeliveryDate: dayjs().format("M/D/YY"),
    donorRequestDate: dayjs().format("M/D/YY"),
    recipientRequestDate: dayjs().format("M/D/YY"),
    donorBloodGroup: "",
    recipientBloodGroup: "",
    donorRH: "",
    recipientRH: "",
    donorDU: "",
    recipientDU: "",
    donorWeight: "",
    bloodQty: "",
    crossMatchResult: "",
    remarks: "",
    performedBy: profile?.data?.fullName || profile?.data?.firstName || "",
    bagNo: "",
    collectionDate: "",
    expiryDate: "",
    bag_componentId: "",
    crossMatchDate: "",
  });

  // Fetch cross match by ID to get complete data
  const fetchCrossMatchById = async (crossMatchId: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BLOOD_BANK}/cross-match/getOneCrossMatchById/${crossMatchId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data?.data) {
        const crossMatch = response.data.data;

        // Set form data from cross match immediately
        setFormData(prev => ({
          ...prev,
          crossMatchResult: crossMatch.crossMatchResult || "",
          remarks: crossMatch.remarks || "",
          bloodQty: crossMatch.bloodQty || "",
          bag_componentId: crossMatch.bag_componentId || "", // Load bag_componentId if present
          crossMatchDate: crossMatch.crossMatchDate || "",
          performedBy: crossMatch.performedBy || prev.performedBy,
        }));

        // Fetch donor and recipient data simultaneously
        if (crossMatch.bagNo) {
          fetchBagById(crossMatch.bagNo.toString());
        }

        if (crossMatch.slipNo) {
          fetchSlipById(crossMatch.slipNo.toString());
        }
      } else {
        toast.error("Cross match data not found");
      }
    } catch (error) {
      console.error("Error fetching cross match by ID:", error);
      toast.error("Failed to fetch cross match data");
    }
  };

  const fetchBagById = async (bagNo: string) => {
    setDonorLoading(true);
    try {
      console.log("Fetching bag with bagNo:", bagNo);
      const response = await axios.get(
        `${
          process.env.REACT_APP_BLOOD_BANK
        }/bag-generation/getBags?bagNo=${encodeURIComponent(bagNo)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("Bag API response:", response.data);

      if (response.data?.data && response.data.data.length > 0) {
        const bag = response.data.data[0]; // Get the first matching bag
        console.log("Found bag:", bag);

        // Set the donor search value with both bag number and donor name
        setDonorSearchValue(`${bag.bagNo || ""}-${bag.donorData?.name || ""}`);
        // Explicitly call handleDonorSelect with the bag data
        handleDonorSelect(bag);
        setIsDonorSelected(true);

        // Also update the donor search results to include this bag
        setDonorSearchResults([bag]);
      } else {
        console.error("No bags found with bagNo:", bagNo);
        toast.error("Bag not found");
      }
    } catch (error) {
      console.error("Error fetching bag by number:", error);
      toast.error("Failed to fetch bag data");
    } finally {
      setDonorLoading(false);
    }
  };

  // Replace the fetchSlipById function with this updated version that uses slipNo instead of slipId
  const fetchSlipById = async (slipNo: string) => {
    setRecipientLoading(true);
    try {
      console.log("Fetching slip with slipNo:", slipNo);
      // Use slipNo instead of slipId for fetching
      const response = await axios.get(
        `${
          process.env.REACT_APP_BLOOD_BANK
        }/patient-slip/getRecipientSlips?slipNo=${encodeURIComponent(slipNo)}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("Slip API response:", response.data);

      if (response.data?.data && response.data.data.length > 0) {
        const slip = response.data.data[0]; // Get the first matching slip
        console.log("Found slip:", slip);

        // Set the recipient search value with both slip number and patient name
        setRecipientSearchValue(
          `${slip.slipNo || ""}-${slip.patientData?.patientName || ""}`
        );

        // Explicitly call handleRecipientSelect with the slip data
        handleRecipientSelect(slip);
        setIsRecipientSelected(true);

        // Also update the recipient search results to include this slip
        setRecipientSearchResults([slip]);
      } else {
        console.error("No slips found with slipNo:", slipNo);
        toast.error("Recipient slip not found");
      }
    } catch (error) {
      console.error("Error fetching recipient slip by number:", error);
      toast.error("Failed to fetch recipient data");
    } finally {
      setRecipientLoading(false);
    }
  };

  // Update the useEffect that loads cross-match data
  useEffect(() => {
    const fetchData = async () => {
      // Always load initial data to populate Autocomplete caches
      fetchBloodBags("");
      handleRecipientSearch("");

      // First check for cross match data (from report page)
      const selectedCrossMatchData = localStorage.getItem("selectetmatches");
      if (selectedCrossMatchData) {
        try {
          const crossMatch = JSON.parse(selectedCrossMatchData);
          console.log("Loading cross match data for editing:", crossMatch);

          // Set edit mode flag
          setIsEditMode(true);
          setCrossMatchId(crossMatch._id || null);

          // Since we already have all the data from the cross-match report,
          // we can directly use it without making additional API calls

          // Set donor data
          if (crossMatch.bagData) {
            setDonorData({
              ...crossMatch.bagData,
              donorData: crossMatch.donorData || { name: "Unknown" },
            });

            // Set donor search value
            setDonorSearchValue(
              `${crossMatch.bagData.bagNo || ""}-${
                crossMatch.donorData?.name || ""
              }`
            );

            // Add to search results so it appears in dropdown
            setDonorSearchResults([
              {
                ...crossMatch.bagData,
                donorData: crossMatch.donorData || { name: "Unknown" },
              },
            ]);

            // Extract blood group and RH factor
            const bloodGroup = crossMatch.bagData.bloodGroup || "";
            const rhFactor =
              crossMatch.bagData.rhFactor === "+" ? "Positive" : "Negative";

            // Update form data with donor details
            setFormData(prev => ({
              ...prev,
              donorId: crossMatch.donorData?.donorId?.toString() || "",
              donorGender: crossMatch.donorData?.gender || "Male/Female",
              donorBloodGroup: bloodGroup,
              donorRH: rhFactor,
              donorDU: crossMatch.bagData.du || "",
              donorWeight: crossMatch.donorData?.vitals?.weight
                ? `${crossMatch.donorData.vitals.weight}kg`
                : "",
              bagNo: crossMatch.bagData.bagNo?.toString() || "",
              collectionDate: crossMatch.bagData.collectionDate
                ? dayjs(crossMatch.bagData.collectionDate).format("M/D/YY")
                : "",
              expiryDate: crossMatch.bagData.expiryDate
                ? dayjs(crossMatch.bagData.expiryDate).format("M/D/YY")
                : "",
              bloodQty:
                crossMatch.bloodQty ||
                "",
              crossMatchResult: crossMatch.crossMatchResult || "",
              remarks: crossMatch.remarks || "",
              bag_componentId: crossMatch.bag_componentId || "", // Load bag_componentId
              crossMatchDate: crossMatch.crossMatchDate || "",
              performedBy: crossMatch.performedBy || prev.performedBy,
            }));
          }

          // Set recipient data
          if (crossMatch.slipData) {
            const recipientWithPatientData = {
              ...crossMatch.slipData,
              patientData: crossMatch.patientDetails || {},
            };

            setRecipientData(recipientWithPatientData);

            // Set recipient search value
            setRecipientSearchValue(
              `${crossMatch.slipData.slipNo || ""}-${
                crossMatch.patientDetails?.patientName || ""
              }`
            );
            setIsRecipientSelected(true);
            // Add to search results so it appears in dropdown
            setRecipientSearchResults([recipientWithPatientData]);

            // Extract blood group and RH factor
            const bloodGroup = crossMatch.slipData.bloodGroup || "";
            const rhFactor =
              crossMatch.slipData.rhFactor === "+" ? "Positive" : "Negative";

            // Update form data with recipient details
            setFormData(prev => ({
              ...prev,
              recipientId: crossMatch.patientDetails?.mrn || "",
              recipientGender:
                crossMatch.patientDetails?.gender || "Male/Female",
              recipientBloodGroup: bloodGroup,
              recipientRH: rhFactor,
              recipientDU: crossMatch.slipData.du || "Negative",
              recipientBedNo: crossMatch.slipData.bedNo || "",
            }));
          }

          // Clear the localStorage
          localStorage.removeItem("selectetmatches");
        } catch (error) {
          console.error("Error parsing selected cross match data:", error);
        }
      } else {
        // Check for selected bag data (from bags page)
        const selectedBagData = localStorage.getItem("selectedBag");
        if (selectedBagData) {
          try {
            const bag = JSON.parse(selectedBagData);
            // Pre-fill the donor search field with the bag number
            setDonorSearchValue(bag.bagNo?.toString() || "");
            // Trigger search to load the bag data
            fetchBloodBags(bag.bagNo?.toString() || "");
            // Clear the localStorage
            localStorage.removeItem("selectedBag");
          } catch (error) {
            console.error("Error parsing selected bag data:", error);
          }
        } else {
          // Load initial data without search terms
          fetchBloodBags("");
          handleRecipientSearch("");
        }
      }
    };
    fetchData();
  }, []);

  // Validate numeric input
  const validateNumericInput = (value: string) => {
    return value.replace(/[^0-9]/g, "");
  };

  // Fetch blood bags data
  const fetchBloodBags = async (searchTerm = "") => {
    if (searchTerm && !searchTerm.trim()) {
      return;
    }

    setDonorLoading(true);
    const url = searchTerm
      ? `${
          process.env.REACT_APP_BLOOD_BANK
        }/bag-generation/getBags?bagNo=${encodeURIComponent(searchTerm)}`
      : `${process.env.REACT_APP_BLOOD_BANK}/bag-generation/getBags`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      console.log("Blood bags API response:", response.data);

      // Check if data array is empty even when API call is successful
      if (response.data?.data?.length > 0) {
        console.log("Blood bags data:", response.data.data);
        setDonorSearchResults(response.data.data);

        // Only update the cache if we're fetching all bags or if we have multiple results
        if (!searchTerm || response.data.data.length > 1) {
          setCachedDonorData(response.data.data); // Cache the data
        }

        // If searching for a specific bag number, find and select it
        if (searchTerm) {
          const matchingBag = response.data.data.find(
            (bag: any) => bag.bagNo?.toString() === searchTerm
          );
          if (matchingBag) {
            handleDonorSelect(matchingBag);
            setIsDonorSelected(true);
          } else {
            console.error("No bag found with bagNo:", searchTerm);
          }
        }
      } else {
        setDonorSearchResults([]);
        if (searchTerm) {
          toast.error("No blood bags found with this bag number");
        }
      }
    } catch (error) {
      console.error("Error fetching blood bags:", error);
      toast.error("Failed to fetch blood bags");
      setDonorSearchResults([]);
    } finally {
      setDonorLoading(false);
    }
  };

  // ---------------------------------------------------------------//

  async function handleRecipientSearch(searchTerm: any) {
    if (searchTerm && !searchTerm.trim()) {
      return;
    }
    // if (!/^\d+$/.test(searchTerm)) {
    //   toast.error("Please enter a valid slip number (numbers only).");
    //   return;
    // }
    setRecipientLoading(true);
    try {
      // searchTerm.parseInt()
      // if (!/^\d+$/.test(searchTerm)) {
      //   return
      // }
      const response = await axios.get(
        `${
          process.env.REACT_APP_BLOOD_BANK
        }/patient-slip/getRecipientSlips?slipNo=${encodeURIComponent(
          searchTerm
        )}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("Recipient API response:", response);
      console.log("Recipient data structure:", response.data);
      console.log("Recipient data array:", response.data?.data);

      // Check if data array is empty even when API call is successful
      if (response.data?.data?.length > 0) {
        console.log("Found recipients:", response.data.data);
        console.log("First recipient details:", response.data.data[0]);
        setRecipientSearchResults(response.data.data);

        // Only update the cache if we're fetching all slips or if we have multiple results
        if (!searchTerm || response.data.data.length > 1) {
          setCachedRecipientData(response.data.data); // Cache the data
        }

        // If searching for a specific slip number, find and select it
        if (searchTerm) {
          const matchingRecipient = response.data.data.find(
            (recipient: any) => recipient.slipNo?.toString() === searchTerm
          );
          if (matchingRecipient) {
            handleRecipientSelect(matchingRecipient);
            setIsRecipientSelected(true);
          }
        }
      } else {
        console.log("No recipients found in response");
        setRecipientSearchResults([]);
        if (searchTerm) {
          toast.error("No recipients found with this slip number");
        }
      }
    } catch (error) {
      console.error("Error searching for recipient:", error);
      setRecipientSearchResults([]);
      if (searchTerm) {
        toast.error("Failed to find recipient");
      }
    } finally {
      setRecipientLoading(false);
    }
  }

  // Handle donor search button click
  const handleDonorSearchClick = () => {
    if (!donorSearchValue.trim()) {
      toast.info("Please enter a valid bag number");
      return;
    }
    fetchBloodBags(donorSearchValue);
    setIsDonorSelected(false);
  };

  // Handle recipient search button click
  const handleRecipientSearchClick = () => {
    if (!recipientSearchValue.trim()) {
      toast.info("Please enter a valid slip number");
      return;
    }
    handleRecipientSearch(recipientSearchValue);
    setIsRecipientSelected(false);
  };

  // Handle donor search with Enter key
  const handleDonorSearchKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isDonorSelected) {
        return;
      }
      if (!donorSearchValue.trim()) {
        toast.info("Please enter a valid bag number");
        return;
      }
      fetchBloodBags(donorSearchValue);
      setIsDonorSelected(false);
    }
  };

  // Handle recipient search with Enter key
  const handleRecipientSearchKeyDown = (
    event: KeyboardEvent<HTMLDivElement>
  ) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (isRecipientSelected) {
        return;
      }
      if (!recipientSearchValue.trim()) {
        toast.info("Please enter a valid slip number");
        return;
      }
      handleRecipientSearch(recipientSearchValue);
      setIsRecipientSelected(false);
    }
  };

  // Filter cached data for donor search
  const filterDonorData = (searchTerm: string) => {
    if (!searchTerm?.trim()) {
      return cachedDonorData;
    }

    // Handle the "BagNo-Name" format by searching for either part
    const searchPart = searchTerm.includes("-")
      ? searchTerm.split("-")[0].trim()
      : searchTerm.trim();

    const lowerCaseSearch = searchPart.toLowerCase();
    return cachedDonorData.filter(
      donor =>
        (donor.bagNo?.toString() || "")
          .toLowerCase()
          .includes(lowerCaseSearch) ||
        (donor.donorData?.name || "").toLowerCase().includes(lowerCaseSearch)
    );
  };

  // Filter cached data for recipient search
  const filterRecipientData = (searchTerm: string) => {
    if (!searchTerm?.trim()) {
      return cachedRecipientData;
    }

    // Handle the "SlipNo-Name" format by searching for either part
    const searchPart = searchTerm.includes("-")
      ? searchTerm.split("-")[0].trim()
      : searchTerm.trim();

    const lowerCaseSearch = searchPart.toLowerCase();
    return cachedRecipientData.filter(
      recipient =>
        (recipient.slipNo?.toString() || "")
          .toLowerCase()
          .includes(lowerCaseSearch) ||
        (recipient.patientData?.patientName || "")
          .toLowerCase()
          .includes(lowerCaseSearch)
    );
  };

  const handleDonorSelect = (donor: any) => {
    setDonorData(donor);
    setDonorSearchValue(`${donor.bagNo || ""}-${donor.donorData?.name || ""}`);
    setIsDonorSelected(true);
    // Extract blood group and RH factor
    const bloodGroup = donor.bloodGroup || "";
    const rhFactor = donor.rhFactor === "+" ? "Positive" : "Negative";

    // Update form data with donor details
    setFormData(prev => ({
      ...prev,
      donorId: donor.donorData?.donorId?.toString() || "",
      donorGender: donor.donorData?.gender || "Male/Female",
      donorBloodGroup: bloodGroup || "",
      donorRH: rhFactor || "",
      donorDU: donor.du || "",
      donorWeight: donor.donorData?.vitals?.weight
        ? `${donor.donorData.vitals.weight}kg`
        : "",
      bagNo: donor.bagNo?.toString() || "",
      collectionDate: donor.collectionDate
        ? dayjs(donor.collectionDate).format("M/D/YY")
        : "",
      expiryDate: donor.expiryDate
        ? dayjs(donor.expiryDate).format("M/D/YY")
        : "",
      bloodQty: donor.bloodQty || "",
      // Reset bag_componentId when a new donor is selected
      bag_componentId: "",
    }));

    // Check compatibility if recipient data is already loaded
    if (recipientData) {
      checkCompatibility(
        bloodGroup,
        rhFactor,
        donor.du || "",
        formData.recipientBloodGroup,
        formData.recipientRH,
        formData.recipientDU
      );
    }
  };

  const handleRecipientSelect = (recipient: any) => {
    console.log("Selected recipient full object:", recipient);
    console.log("Recipient patient details:", recipient.patientData);
    console.log("Recipient slip number:", recipient.slipNo);
    console.log("Recipient blood group:", recipient.bloodGroup);
    console.log("Recipient RH factor:", recipient.rhFactor);

    setRecipientData(recipient);
    setRecipientSearchValue(
      `${recipient.slipNo || ""}-${recipient.patientData?.patientName || ""}`
    );
    setIsRecipientSelected(true);

    // Extract blood group and RH factor from recipient data
    const bloodGroup = recipient.bloodGroup || "";
    const rhFactor = recipient.rhFactor === "+" ? "Positive" : "Negative";

    console.log("Extracted blood group:", bloodGroup);
    console.log("Extracted RH factor:", rhFactor);

    // Update form data with recipient details
    setFormData(prev => ({
      ...prev,
      recipientId: recipient.patientData?.mrn || "",
      recipientGender: recipient.patientData?.gender || "Male/Female",
      recipientBloodGroup: bloodGroup,
      recipientRH: rhFactor,
      recipientDU: recipient.du || "Negative",
      recipientBedNo: recipient.bedNo || "",
      recipientDeliveryDate: dayjs().format("M/D/YY"), // Always set to today's date
      recipientRequestDate: dayjs().format("M/D/YY"),
    }));

    console.log("Updated form data with recipient:", formData);

    // Check compatibility if donor data is already loaded
    if (donorData) {
      console.log("Checking compatibility with donor data:", donorData);
      checkCompatibility(
        formData.donorBloodGroup,
        formData.donorRH,
        formData.donorDU,
        bloodGroup,
        rhFactor,
        recipient.du || "Negative"
      );
    }
  };
  // Separate handlers for text inputs and select inputs
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handler for blood quantity with validation (0-999 only)
  const handleBloodQtyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;
    
    // Allow empty string
    if (value === "") {
      setFormData({
        ...formData,
        bloodQty: "",
      });
      return;
    }
    
    // Remove non-numeric characters
    value = value.replace(/[^0-9]/g, "");
    
    // Limit to 999
    if (value && parseInt(value, 10) > 999) {
      value = "999";
    }
    
    setFormData({
      ...formData,
      bloodQty: value,
    });
  };

  const handleSelectChange = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDateChange = (field: string, date: any) => {
    setFormData({
      ...formData,
      [field]: date ? dayjs(date).format("M/D/YY") : "",
    });
  };

  // Function to check blood compatibility
  const checkCompatibility = (
    donorBloodGroup: string,
    donorRH: string,
    donorDU: string,
    recipientBloodGroup: string,
    recipientRH: string,
    recipientDU: string
  ) => {
    // Check if blood group, RH, and DU match
    const isCompatible =
      donorBloodGroup === recipientBloodGroup && donorRH === recipientRH;

    // Only update if we're not in edit mode or if the result is currently empty
    if (!isEditMode || !formData.crossMatchResult) {
      setFormData(prev => ({
        ...prev,
        crossMatchResult: isCompatible ? "Compatible" : "Incompatible",
      }));
    }
  };

  // Update the handleSave function to properly handle updates
  const handleSave = async () => {
    try {
      // Validate required fields
      if (!donorData || !recipientData) {
        toast.error("Please select both donor and recipient");
        return;
      }
      if (!formData.bag_componentId) {
        toast.error("Please select a blood component");
        return;
      }

      // Validate blood quantity and remarks
      // if (!formData.bloodQuantity.trim()) {
      //   toast.error("Please enter blood quantity");
      //   return;
      // }

      // if (!formData.remarks.trim()) {
      //   toast.error("Please enter remarks")
      //   return
      // }

      // Show loading indicator
      // toast.info("Processing request...", { autoClose: false, toastId: "saving-toast" })

      // Check for existing cross-match with same bagNo and slipNo
      // if (!isEditMode) {
      //   try {
      //     // const checkResponse = await axios.get(
      //     //   `${process.env.REACT_APP_BLOOD_BANK}/cross-match/findAllCrossMatches?bagNo=${donorData.bagNo}&slipNo=${recipientData.slipNo}`,
      //     //   {
      //     //     headers: {
      //     //       Authorization: `Bearer ${localStorage.getItem("token")}`,
      //     //     },
      //     //   }
      //     // );

      //     // if (checkResponse.data?.data && checkResponse.data.data.length > 0) {
      //     //   // toast.dismiss("saving-toast")
      //     //   toast.error(
      //     //     "A cross-match with this bag number and slip number already exists"
      //     //   );
      //     //   return;
      //     // }
      //   } catch (checkError) {
      //     console.error(
      //       "Error checking for duplicate cross-match:",
      //       checkError
      //     );
      //     // Continue with save attempt even if check fails
      //   }
      // }

      // Create payload according to the required schema
      const payload = {
        patientSlipId: recipientData._id || "",
        bagId: donorData._id || "",
        crossMatchDate: isEditMode
          ? formData.crossMatchDate || new Date().toISOString()
          : new Date().toISOString(),
        crossMatchResult: formData.crossMatchResult || "",
        remarks: formData.remarks || "",
        bloodQty: formData.bloodQty || "",
        performedBy: formData.performedBy || "",
        bag_componentId: formData.bag_componentId || "",
        // Add these fields to ensure they're available in the report if needed by the frontend/backend
        bagNo: donorData.bagNo || "",
        slipNo: recipientData.slipNo || "",
        donorId: donorData.donorData?.donorId || "",
        bloodGroup: donorData.bloodGroup || "",
        du: donorData.du || "",
      };

      console.log("Sending payload to API:", payload);

      let response;

      if (isEditMode && crossMatchId) {
        // Update existing cross match
        try {
          console.log(`Updating cross match with ID: ${crossMatchId}`);
          response = await axios.put(
            `${process.env.REACT_APP_BLOOD_BANK}/cross-match/updateCrossMatchById/${crossMatchId}`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          console.log("Update response:", response.data);
          if (response.data.isSuccess) {
            // toast.dismiss("saving-toast")
            toast.success("Blood cross match updated successfully");
          } else {
            // toast.dismiss("saving-toast")
            toast.error(
              `Failed to update: ${response.data.message || "Unknown error"}`
            );
            return;
          }
        } catch (updateError) {
          console.error("Error with update endpoint:", updateError);
          // toast.dismiss("saving-toast")
          toast.error(
            `Failed to update: ${
              (updateError as any)?.response?.data?.message || "Unknown error"
            }`
          );
          return;
        }
      } else {
        // Create new cross match
        try {
          response = await axios.post(
            `${process.env.REACT_APP_BLOOD_BANK}/cross-match/createCrossMatch`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          console.log("Create response:", response.data);
          if (response.data.isSuccess) {
            // toast.dismiss("saving-toast")
            toast.success("Blood cross match saved successfully");
          } else {
            // toast.dismiss("saving-toast")
            toast.info(`${response.data.message || "Unknown error"}`);
            return;
          }
        } catch (createError) {
          console.error("Error creating cross match:", createError);
          // toast.dismiss("saving-toast")
          toast.error(
            `Failed to save: ${
              (createError as any)?.response?.data?.message || "Unknown error"
            }`
          );
          return;
        }
      }

      // Clear form data from localStorage to prevent persistence
      localStorage.removeItem("selectetmatches");
      localStorage.removeItem("selectedBag");

      // Reset form state
      resetForm();

      // Store the complete cross match data for printing
      const crossMatchForPrint = {
        ...payload,
        bagNo: donorData.bagNo,
        slipNo: recipientData.slipNo,
        performedBy: profile?.data?.fullName || profile?.data?.firstName || "",
        bagData: {
          ...donorData,
          bloodQty: formData.bloodQty,
          collectionDate: donorData.collectionDate || new Date().toISOString(),
          expiryDate: donorData.expiryDate || new Date().toISOString(),
        },
        donorData: donorData.donorData || {},
        slipData: {
          ...recipientData,
          bloodGroup: recipientData.bloodGroup || "",
          rhFactor: recipientData.rhFactor || "",
          du: recipientData.du || "",
        },
        patientDetails: {
          ...recipientData.patientData,
          patientName: recipientData.patientData?.patientName || "",
          mrn: recipientData.patientData?.mrn || "",
          gender: recipientData.patientData?.gender || "",
        },
        crossMatchResult: formData.crossMatchResult,
        remarks: formData.remarks || "",
        bloodQty: formData.bloodQty,
        crossMatchDate: new Date().toISOString(),
        bag_componentId: formData.bag_componentId,
      };

      localStorage.setItem(
        "newlyAddedCrossMatch",
        JSON.stringify(crossMatchForPrint)
      );

      navigate("/blood-bank/cross-match-report");
    } catch (error) {
      console.error("Error in handleSave:", error);
      // toast.dismiss("saving-toast");
      toast.error(
        `Failed to ${isEditMode ? "update" : "save"} blood cross match: ${
          (error as any)?.response?.data?.message || "Unknown error"
        }`
      );
    }
  };

  const resetForm = () => {
    // Clear all form data
    setFormData({
      donorId: "",
      recipientId: "",
      donorBedNo: "",
      recipientBedNo: "",
      donorGender: "Male/Female",
      recipientGender: "Male/Female",
      donorDeliveryDate: dayjs().format("M/D/YY"),
      recipientDeliveryDate: dayjs().format("M/D/YY"),
      donorRequestDate: dayjs().format("M/D/YY"),
      recipientRequestDate: dayjs().format("M/D/YY"),
      donorBloodGroup: "",
      recipientBloodGroup: "",
      donorRH: "",
      recipientRH: "",
      donorDU: "",
      recipientDU: "",
      donorWeight: "",
      bloodQty: "",
      crossMatchResult: "",
      remarks: "",
      performedBy: profile?.data?.firstName || "",
      bagNo: "",
      collectionDate: "",
      expiryDate: "",
      bag_componentId: "",
      crossMatchDate: "",
    });

    // Clear donor and recipient data
    setDonorData(null);
    setRecipientData(null);
    setDonorSearchValue("");
    setRecipientSearchValue("");
    setCrossMatchId(null);
    setIsEditMode(false);

    // Clear localStorage to prevent data persistence
    localStorage.removeItem("selectetmatches");
    localStorage.removeItem("selectedBag");
  };

  const handlePrint = () => {
    // Implement print functionality
    window.print();
  };

  const LabelValuePair = ({
    label,
    value,
    fontSize = "12px", // Add fontSize prop with default value
  }: {
    label: string;
    value: string;
    fontSize?: string; // Optional fontSize prop
  }) => {
    // Check if this is a blood group or RH label
    const isBloodGroupOrRH = label === "B.Group" || label === "RH";

    // Determine background color based on compatibility
    let backgroundColor = "transparent";
    let color = "#666";
    if (
      isBloodGroupOrRH &&
      formData.donorBloodGroup &&
      formData.recipientBloodGroup
    ) {
      // Check if both blood group and RH match
      const isCompatible =
        formData.donorBloodGroup === formData.recipientBloodGroup &&
        formData.donorRH === formData.recipientRH;

      // Apply background color based on compatibility
      backgroundColor = isCompatible ? "#85e085" : "#ff8080";
      color = isCompatible ? "white" : "white";
    }

    return (
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Typography
          variant="body2"
          // color="textSecondary"
          sx={{
            width: "100px",
            color: "black",
            fontWeight: "500",
            fontSize: fontSize,
          }} // Use fontSize prop
        >
          {label}:
        </Typography>
        <Typography
          variant="body2"
          sx={{
            backgroundColor: isBloodGroupOrRH ? backgroundColor : "transparent",
            padding: isBloodGroupOrRH ? "2px 0" : "2px 0",
            borderRadius: isBloodGroupOrRH ? "4px" : "0",
            width: "100%",
            fontSize: fontSize, // Use fontSize prop
          }}
        >
          {value || "N/A"}
        </Typography>
      </Box>
    );
  };

  // Add this useEffect to clean up when component unmounts
  useEffect(() => {
    return () => {
      // Clean up localStorage when component unmounts
      localStorage.removeItem("selectetmatches");
      localStorage.removeItem("selectedBag");
    };
  }, []);

  // Modify the setDonorSearchValue function to reset the dropdown options when clearing
  const handleDonorInputChange = (event: any, newInputValue: string) => {
    setDonorSearchValue(newInputValue);
    setIsDonorSelected(false);

    // If the field is being cleared, reset the dropdown options to show cached data
    if (!newInputValue.trim()) {
      setDonorSearchResults(cachedDonorData);
    }
  };

  // Modify the setRecipientSearchValue function to reset the dropdown options when clearing
  const handleRecipientInputChange = (event: any, newInputValue: string) => {
    setRecipientSearchValue(newInputValue);
    setIsRecipientSelected(false);
    // If the field is being cleared, reset the dropdown options to show cached data
    if (!newInputValue.trim()) {
      setRecipientSearchResults(cachedRecipientData);
    }
  };

  return (
    <Box>
      {/* Header */}

      {/* Main Content */}
      <Paper sx={{ p: 2, borderRadius: "8px" }}>
        <Box sx={{ background: "#fff", p: 1, borderRadius: "8px", mb: 1 }}>
          <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
            {isEditMode ? "Edit Cross Match" : "Donor / Recipient Cross Match"}
          </Typography>
        </Box>
        <Grid container spacing={3}>
          {/* Left Side - Donor */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "1px 1px 12px rgba(22, 22, 22, 0.1)",
                bgcolor: "#fff",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                <Box>
                  {/* Donor Search */}
                  <CardHeader
                    title={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Left side - Title */}
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 600, color: "#333" }}
                        >
                          Donor (Bag)
                        </Typography>

                        {/* Right side - Bag No Autocomplete */}
                        <Box
                          sx={{ display: "flex", alignItems: "center", ml: 2 }}
                        >
                          <Box
                            ref={donorSearchRef}
                            sx={{
                              position: "relative",
                              flexGrow: 1,
                              minWidth: "300px",
                            }}
                          >
                            <Autocomplete
                              freeSolo
                              openOnFocus
                              options={filterDonorData(donorSearchValue)}
                              getOptionLabel={option => {
                                if (typeof option === "string") return option;
                                return `${option.bagNo || ""}-${
                                  option.donorData?.name || ""
                                }`;
                              }}
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  key={option._id}
                                  style={{ fontSize: "12px" }}
                                >
                                  {option.bagNo || ""}-
                                  {option.donorData?.name || ""}
                                </li>
                              )}
                              inputValue={donorSearchValue}
                              onInputChange={(event, newInputValue) => {
                                handleDonorInputChange(event, newInputValue);
                              }}
                              onChange={(event, newValue) => {
                                if (
                                  newValue &&
                                  typeof newValue !== "string"
                                ) {
                                  handleDonorSelect(newValue);
                                }
                              }}
                              loading={donorLoading}
                              renderInput={params => (
                                <TextField
                                  className="custom-input"
                                  {...params}
                                  placeholder="Enter bag number"
                                  size="small"
                                  // className="search-field"
                                  onKeyDown={handleDonorSearchKeyDown}
                                  InputProps={{
                                    ...params.InputProps,
                                    style: { fontSize: "12px" },
                                    endAdornment: (
                                      <>
                                        {donorLoading ? (
                                          <CircularProgress size={16} />
                                        ) : (
                                          <InputAdornment position="end">
                                            <IconButton
                                              onClick={handleDonorSearchClick}
                                              edge="end"
                                              size="small"
                                              disabled={isDonorSelected}
                                            >
                                              <SearchIcon fontSize="small" />
                                            </IconButton>
                                          </InputAdornment>
                                        )}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              ListboxProps={{
                                style: { maxHeight: "200px", overflow: "auto" },
                              }}
                              slotProps={{
                                popper: {
                                  modifiers: [
                                    {
                                      name: "sameWidth",
                                      enabled: true,
                                      phase: "beforeWrite",
                                      requires: ["computeStyles"],
                                      fn: ({ state }) => {
                                        state.styles.popper.width = `${state.rects.reference.width}px`;
                                      },
                                    },
                                  ],
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    }
                    sx={{
                      // bgcolor: "#f8f9fa",
                      borderBottom: "1px solid #e0e0e0",
                      py: 1,
                    }}
                  />

                  <Grid container spacing={2} px={2} pt={1}>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="Name"
                        value={donorData?.donorData?.name || ""}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="Gender"
                        value={formData.donorGender}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <LabelValuePair
                        label="B.Group"
                        value={formData.donorBloodGroup}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair label="RH" value={formData.donorRH} />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair label="DU" value={formData.donorDU} />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="Weight"
                        value={formData.donorWeight}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="C.Date"
                        value={formData.collectionDate}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="E.Date"
                        value={formData.expiryDate}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Side - Recipient */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "1px 1px 12px rgba(22, 22, 22, 0.1)",
                bgcolor: "#fff",
              }}
            >
              <CardContent sx={{ p: 1 }}>
                <Box>
                  {/* Recipient Search */}
                  <CardHeader
                    title={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Left side - Title */}
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 600, color: "#333" }}
                        >
                          Recipient (Slip)
                        </Typography>

                        <Box
                          sx={{ display: "flex", alignItems: "center", ml: 2 }}
                        >
                          <Box
                            ref={recipientSearchRef}
                            sx={{
                              position: "relative",
                              flexGrow: 1,
                              minWidth: "270px",
                            }}
                          >
                            <Autocomplete
                              freeSolo
                              openOnFocus
                              options={filterRecipientData(
                                recipientSearchValue
                              )}
                              getOptionLabel={option => {
                                if (typeof option === "string") return option;
                                return `${option.slipNo || ""}-${
                                  option.patientData?.patientName || ""
                                }`;
                              }}
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  key={option._id}
                                  style={{ fontSize: "12px" }}
                                >
                                  {option.slipNo || ""}-
                                  {option.patientData?.patientName || ""}
                                </li>
                              )}
                              inputValue={recipientSearchValue}
                              onInputChange={(event, newInputValue) => {
                                handleRecipientInputChange(
                                  event,
                                  newInputValue
                                );
                              }}
                              onChange={(event, newValue) => {
                                if (
                                  newValue &&
                                  typeof newValue !== "string"
                                ) {
                                  handleRecipientSelect(newValue);
                                }
                              }}
                              loading={recipientLoading}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  placeholder="Enter slip number"
                                  size="small"
                                  className="custom-input"
                                  onKeyDown={handleRecipientSearchKeyDown}
                                  InputProps={{
                                    ...params.InputProps,
                                    style: { fontSize: "12px" },
                                    endAdornment: (
                                      <>
                                        {recipientLoading ? (
                                          <CircularProgress size={16} />
                                        ) : (
                                          <InputAdornment position="end">
                                            <IconButton
                                              onClick={
                                                handleRecipientSearchClick
                                              }
                                              edge="end"
                                              size="small"
                                              disabled={isRecipientSelected}
                                            >
                                              <SearchIcon fontSize="small" />
                                            </IconButton>
                                          </InputAdornment>
                                        )}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                />
                              )}
                              ListboxProps={{
                                style: { maxHeight: "200px", overflow: "auto" },
                              }}
                              slotProps={{
                                popper: {
                                  modifiers: [
                                    {
                                      name: "sameWidth",
                                      enabled: true,
                                      phase: "beforeWrite",
                                      requires: ["computeStyles"],
                                      fn: ({ state }) => {
                                        state.styles.popper.width = `${state.rects.reference.width}px`;
                                      },
                                    },
                                  ],
                                },
                              }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    }
                    sx={{
                      // bgcolor: "#f8f9fa",
                      borderBottom: "1px solid #e0e0e0",
                      py: 1,
                    }}
                  />

                  {/* Recipient Info - Two columns per row */}
                  <Grid container spacing={2} px={2} pt={1}>
                    <Grid item xs={6}>
                      <div style={{ fontSize: "180px" }}>
                        <LabelValuePair
                          label="Name"
                          value={recipientData?.patientData?.patientName || ""}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="MRN"
                        value={recipientData?.patientData?.mrn || ""}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <LabelValuePair
                        label="B.Group"
                        value={formData.recipientBloodGroup}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair label="RH" value={formData.recipientRH} />
                    </Grid>

                    <Grid item xs={6}>
                      <LabelValuePair label="DU" value={formData.recipientDU} />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="Bed No"
                        value={formData.recipientBedNo}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <LabelValuePair
                        label="Date"
                        value={dayjs().format("M/D/YY")}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Bottom Section - Cross Match Details */}
          <Grid item xs={12}>
            <Card
              sx={{
                borderRadius: "12px",
                border: "none",
                boxShadow: "1px 1px 12px rgba(22, 22, 22, 0.1)",
                bgcolor: "#fff",
              }}
            >
              <CardContent sx={{ p: 2 }}>
                <Box sx={{ mt: 0.5 }}>
                  <Grid container spacing={2}>
                    {/* Left Side e bottom section  */}
                    <Grid item xs={12} md={6}>
                      {/* Blood Component and Blood Quantity on same row */}
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                              mb: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                width: "150px",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Blood Component:
                            </Typography>
                            <FormControl
                              size="small"
                              sx={{ width: "auto" }}
                              disabled={!donorData}
                            >
                              <InputLabel sx={{ fontSize: "12px" }}>
                                Select Component
                              </InputLabel>
                              <Select
                                className="custom-input"
                                name="bag_componentId"
                                value={formData.bag_componentId || ""}
                                onChange={(e: SelectChangeEvent<string>) => {
                                  const selectedId = e.target.value;
                                  // Find the selected component to get its expiry date
                                  const selectedComponent = donorData?.bagComponents?.find(
                                    (comp: any) => comp._id === selectedId
                                  );
                                  
                                  setFormData(prev => ({
                                    ...prev,
                                    bag_componentId: selectedId,
                                    expiryDate: selectedComponent?.expiryDate 
                                      ? dayjs(selectedComponent.expiryDate).format("M/D/YY")
                                      : prev.expiryDate,
                                  }));
                                }}
                                size="small"
                                // sx={{ fontSize: "12px" }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {donorData?.bagComponents
                                  ?.filter(
                                    (comp: any) => comp.status === "ACTIVE"
                                  )
                                  .map((comp: any, index: number) => (
                                    <MenuItem
                                      key={comp._id || `comp-${index}`}
                                      value={comp._id || `comp-${index}`}
                                      sx={{ fontSize: "12px" }}
                                    >
                                      {comp.component}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </Box>
                        </Grid>

                        <Grid item xs={6}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                              mb: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                width: "150px",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Blood Quantity:
                            </Typography>
                            <FormControl size="small" sx={{ width: "auto" }}>
                              <TextField
                                className="custom-input"
                                name="bloodQty"
                                value={formData.bloodQty}
                                onChange={handleBloodQtyChange}
                                size="small"
                                inputProps={{
                                  maxLength: "3",
                                  placeholder: "0-999",
                                  pattern: "[0-9]*",
                                }}
                                InputProps={{
                                  style: { fontSize: "12px" },
                                  endAdornment: (
                                    <InputAdornment
                                      position="end"
                                      sx={{ fontSize: "10px" }}
                                    >
                                      ml
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </FormControl>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Remarks on next row, full width */}
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                width: "150px",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Remarks:
                            </Typography>
                            <TextField
                              className="custom-input"
                              name="remarks"
                              value={formData.remarks}
                              onChange={handleTextChange}
                              size="small"
                              fullWidth
                              InputProps={{ style: { fontSize: "12px" } }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Righ side bottom section Side */}
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            width: "150px",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Cross Match Result:
                        </Typography>

                        <FormControl size="small" sx={{ width: "auto" }}>
                          <Select
                            className="custom-input"
                            name="crossMatchResult"
                            value={formData.crossMatchResult || ""} // fallback to empty string
                            onChange={handleSelectChange}
                            size="small"
                            // sx={{ fontSize: "12px" }}
                            displayEmpty // <-- placeholder ko show karne ke liye
                          >
                            {/* Placeholder */}
                            <MenuItem
                              value=""
                              disabled
                              // sx={{ fontSize: "12px", color: "gray" }}
                            >
                              Select Result
                            </MenuItem>

                            <MenuItem
                              value="Compatible"
                              sx={{ fontSize: "12px" }}
                            >
                              Compatible
                            </MenuItem>
                            <MenuItem
                              value="Incompatible"
                              sx={{ fontSize: "12px" }}
                            >
                              Incompatible
                            </MenuItem>
                            <MenuItem value="Pending" sx={{ fontSize: "12px" }}>
                              Pending
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          mt: 1,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            width: "150px",
                            fontWeight: "600",
                            fontSize: "14px",
                          }}
                        >
                          Performed By:
                        </Typography>
                        <TextField
                          className="custom-input"
                          name="performedBy"
                          value={formData.performedBy}
                          onChange={handleTextChange}
                          size="small"
                          sx={{ width: "auto" }}
                          InputProps={{
                            readOnly: true,
                            style: { fontSize: "12px" },
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      mt: 1,
                      gap: 2,
                    }}
                  >
                    <Button variant="outlined" onClick={resetForm} size="small">
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSave}
                      size="small"
                    >
                      {isEditMode ? "Update" : "Save"}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default BloodCrossmatch;
